<app-gmao-spinner *ngIf="!installation"></app-gmao-spinner>

<ng-container *ngIf="installation">
    <br>
    <div class="shadowed row justify-content-center installation-head">

        <div class="attributs">
            <p >Nom : </p>
            <p >{{installation.nom_installation}}</p>
        </div>

        <div class="attributs">
            <p >Propriétaire : </p>
            <ng-container *ngIf=" installation.societe_proprietaire.proprietaires">
                <ng-container >
                    <p  >{{ getCorrectInstallProprioDisplay(installation.societe_proprietaire.proprietaires) }}</p>
                </ng-container>
            </ng-container>
        </div>

        <div class="attributs">
            <p >Société : </p>
            <p >{{installation.societe_proprietaire.raison_sociale}} ({{installation.societe_proprietaire.code_ebp}})</p>
        </div>

        <div>
            <p>Modèle: </p>
            <p>{{ getMOdelInstallationName(installation) }}</p>
        </div>

        <div class="attributs">
            <p >Machine : </p> 
            <ng-container *ngIf="!restricted">
                <p ><a routerLink="/machine/{{installation.machine.id_machine}}">{{installation.machine.numero_serie}} ({{installation.machine.cote_portes}})</a></p>
            </ng-container>
            <ng-container *ngIf="restricted">
                <p >{{installation.machine.numero_serie}} ({{installation.machine.cote_portes}})</p>
            </ng-container>

        </div>
 
        <div class="attributs">
            <ng-container *ngIf="contratSav">
                <p >Contrat SAV :  </p>
                <p >{{contratSav.nom_contrat}}</p>
            </ng-container>
        </div>
       
        <div class="attributs">
            <p >IP : </p>
            <p >{{ getInstallationIPAdress(installation) }}</p> 
        </div>
       
        <div class="attributs">
            <p >Cartons : </p>
            <p class="orange-adial" >{{ installation.champs.Cartons.valeur_champ }}</p> 
        </div>

        <!-- <p class="col-6 col-sm-3 installation-warranty">&nbsp;</p> -->
             
    </div>
    <br>
    <br>
    <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Propriétés" *ngIf="!restricted">
            <app-installation-properties [installation]="installation"></app-installation-properties>
        </mat-tab>
        <mat-tab label="Connexions">
            <app-installation-connections [installation]="installation"></app-installation-connections>
        </mat-tab>
        <mat-tab label="Ventes">
            <app-installation-sales [installation]="installation"></app-installation-sales>
        </mat-tab>
        <mat-tab label="Statistiques">
            <app-installation-statistics [installation]="installation"></app-installation-statistics>
        </mat-tab>
        <mat-tab label="Incidents" *ngIf="!restricted">
            <app-installation-incidents [installation]="installation"></app-installation-incidents>
        </mat-tab>
        <mat-tab label="Interventions" >
            <app-installation-interventions [idMachine]="installation.machine.id_machine" [suiviCount]="installation.machine.sav_suivis_count"></app-installation-interventions>
        </mat-tab>
        <!-- <mat-tab label="Documents">
            <app-installation-photos [installation]="installation"></app-installation-photos>
        </mat-tab> -->
        <!-- <mat-tab label="Divers">
            <app-installation-miscellaneous></app-installation-miscellaneous>
        </mat-tab> -->
    </mat-tab-group>

</ng-container>